import { useParams } from "react-router-dom";
import DetailsBanner from "../../components/DetailsBanner";
import Similar from "../../components/Similar";
import useFetch from "../../hooks/useFetch";

type Props = {};

const Details = (props: Props) => {
  const { id } = useParams();
  const { data, loading, error } = useFetch(`/event_slug/${id}`);
  console.log(data);

  return (
    <div>
      <DetailsBanner id={id} data={data} loading={loading} error={error} />

      <Similar />
    </div>
  );
};

export default Details;
